import uuid from 'uuid';
import { textRichUtils } from '@nextiva/rich-text-editor';

// Using textRichUtils to create @draft-js Content state from plain text if option doesn't have it @sinslav
export default (plainText, config = {}) => ({
  id: uuid(),
  value: plainText,
  content: textRichUtils.convertStringToRawContent(plainText),
  ...config,
});
